import { render, staticRenderFns } from "./EducationCard.vue?vue&type=template&id=d53922fe&scoped=true"
import script from "./EducationCard.vue?vue&type=script&lang=js"
export * from "./EducationCard.vue?vue&type=script&lang=js"
import style0 from "./EducationCard.vue?vue&type=style&index=0&id=d53922fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53922fe",
  null
  
)

export default component.exports